import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NibrasClient } from '@nibras/core/common';
import { concat, uniq } from 'lodash';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppCacheService } from './app-cache.service';
import { AuthService } from './auth/auth.service';
import { AppCache, RequestLogHeader } from './model/app-cache.model';

@Injectable()
export class HttpApplicationInterceptor implements HttpInterceptor {
  constructor(
    public route: Router,
    private authService: AuthService,
    private appCacheService: AppCacheService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isAzureDevOpsRequest = req.url.includes('dev.azure.com');
    if (isAzureDevOpsRequest) {
      return next.handle(req);
    }

    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    const imp = localStorage.getItem('imp');
    let headers = req.headers.append('NXToken', this.authService.NXToken || emptyGuid);
    headers = headers.append('X-ClientId', NibrasClient.Web.toString());

    const token = this.authService.getAccessToken();
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }

    if (imp) {
      headers = headers.append('X-Imp', imp);
    }
    if (this.authService.NXToken !== emptyGuid) {
      const selectedApp = this.appCacheService.getSelectedApp();
      if (selectedApp) {
        const requestLogHeader: RequestLogHeader = {
          AppID: selectedApp.appId,
          WidgetID: selectedApp.widgetId,
          ActivityInstanceID: selectedApp?.activityID ?? selectedApp?.processParams?.ActivityID,
          ProcessInstanceID: selectedApp?.processParams?.Id,
          Scope: selectedApp.appConfig?.ShowBreadcrumb ? this.getAssetTags(selectedApp) : null
        };
        headers = headers.append('RequestLogHeader', JSON.stringify(requestLogHeader));
      }
    }

    const authReq = req.clone({
      headers,
      withCredentials: true
    });

    return next.handle(authReq).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
        },
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.route.navigate(['/login']);
            }
          }
        }
      })
    );
  }

  private getAssetTags(appCache: AppCache) {
    return uniq(concat(appCache?.getSidebarTagsValue(), appCache.hierarchyData?.profileTagList));
  }
}
